module.exports = __webpack_public_path__ + "img/update.918525b4.svg";